define(function (require) {
    "use strict";

    var LE = require("app");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var DataSourcesAttributesModel = require("manager-models/DataSourcesAttributesModel");
    var DataSourcesAttributesCollection = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesAttributesCollection = Backbone.Collection.extend({
            model : DataSourcesAttributesModel,

            getById: function(id){
                return this.get(id);
            },
            areAllPropertiesBlank: function(agent){
                var result = true;
                var iterator = this.models.length;
                var model;

                while (result && iterator) {
                    iterator--;
                    model = this.models[iterator];
                    result = result && model.arePropertiesBlank(agent);
                }

                return result;
            },
            areAllPropertiesValid: function(){
                var result = true;
                this.each(function (model) {
                    result = result && model.arePropertiesValid();
                });
                return result;
            },

            getUnsavedAttributesData: function () {
                var result = [];
                this.each(function (model) {
                    if (model.hasUnsavedAgentOutcomeProperties || model.hasUnsavedScraperProperties) {
                        var tabType = model.hasUnsavedAgentOutcomeProperties ? ManagerConfig.dataSources.mainConfig.tabType.agent : ManagerConfig.dataSources.mainConfig.tabType.scraper;
                        result.push({id: model.id, tabType: tabType, name: model.getName()});
                    }
                });
                return result;
            },

            resetUnsavedScraperAttributesData: function () {
                this.each(function (model) {
                    model.hasUnsavedScraperProperties = false;
                });
            }

        });
    });

    return DataSourcesAttributesCollection;
});
